import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Row, Col, Form} from 'react-bootstrap'
import {useLocation, useNavigate} from "react-router-dom";
import Send from "../../components/Icons/Send";
import {getTemplateColumns, resetSendLettersNotices, sendLettersNotices} from "../../actions/LetterNoticesActions";
import HTMLViewer from "../../components/HTMLViewer";
import Loader from "../../components/Loader";
import AlertModal from "../../components/AlertModal";
import {getTeacherAssociates} from "../../actions/ConfigActions";

function LettersPreviewManualTab(props) {
    const history = useNavigate();
    const location = useLocation()
    const dispatch = useDispatch()
    const [inputs, setInputs] = useState([]);
    const [inputsEmail, setInputsEmail] = useState([]);
    const [teacher, setTeacher] = useState([])
    const [concatColumns, setConcatColumns] = useState([]);
    const [sentToList, setSentToList] = useState([]);
    const [sentToListEmail, setSentToListEmail] = useState([]);
    const [templateColumn, setTemplateColumn] = useState({
        letterTemplateId: "",
        title: "",
        descriptions: "",
        manualDynamicColumns: "",
        sortedDynamicColumns: "",
    });
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    });
    const [fieldData, setFieldData] = useState({
        isSignRequired: false,
    });
    const [templateColumnValues, setTemplateColumnValues] = useState([])
    const [templateColumnValuesEmail, setTemplateColumnValuesEmail] = useState([])
    const [submit, setSubmit] = useState(true);
    const [submitEmail, setSubmitEmail] = useState(true);
    const [dynamicColumns, setDynamicColumns] = useState(false);
    const [dynamicColumnsEmail, setDynamicColumnsEmail] = useState(false);

    const getTeacherList = useSelector(state => state.getTeacherAssociate)

    const getTemplateColumnDetails = useSelector(state => state.getTemplateColumn)
    const {error, loading, template_column} = getTemplateColumnDetails

    useEffect(() => {
        if (!getTeacherList.teacher_list <= 0) {
            setTeacher([])
            getTeacherList.teacher_list.map((item, index) => {
                setTeacher((prevData) => [
                    ...prevData,
                    {
                        id: item.employee_ID,
                        data: `${item?.employee_First_Name || ''} ${item?.employee_Last_Name || ''}`,
                    }
                ])
            });
        }
    }, [getTeacherList.teacher_list]);

    const gotoLetters = () => {
        dispatch(sendLettersNotices(location.state?.templateId, template_column?.documentText, sentToList, sentToListEmail, fieldData.isSignRequired))
    }
    const sendLettersNoticesDetails = useSelector(state => state.sendLettersNotices)
    const { loadingSend } = sendLettersNoticesDetails

    useEffect(() => {
        if (sendLettersNoticesDetails.letters_notices === true) {
            dispatch(resetSendLettersNotices())
            history('/letters-notices', {
                state: {
                    name: "1",
                    "message": `Letters Sent Successfully to ${(location.state?.userList.length + location.state?.emails.length - location.state?.emailCheck.length)}/${location.state?.userList.length + location.state?.emails.length} teachers/associates`
                }
            })
        }
        if (sendLettersNoticesDetails.error) {
            setAlertModal({
                display: true,
                type: error,
                message: "Letters/Notices couldn't be added"
            })
        }
    }, [sendLettersNoticesDetails]);

    useEffect(() => {
        dispatch(getTeacherAssociates())
        dispatch(getTemplateColumns(location.state?.templateId))

        if (location.state?.emails.length > 0) {
            setDynamicColumnsEmail(true)
        }
    }, []);

    useEffect(() => {
        let manualAndCustomDynamicColumns = [
                ...getTemplateColumnDetails.template_column?.manualDynamicColumns || [],
                ...getTemplateColumnDetails.template_column?.customDynamicColumns || [],
            ]

        const manualDynamicColumns = getManualDynamicColumns(manualAndCustomDynamicColumns);
        console.log(manualDynamicColumns)

        setTemplateColumn([]);
        setFieldData({isSignRequired: !!getTemplateColumnDetails?.template_column?.isSignRequired});

        if (!getTemplateColumnDetails.template_column <= 0) {
            setTemplateColumn({
                ...templateColumn,
                letterTemplateId: getTemplateColumnDetails.template_column.letterTemplateId,
                title: getTemplateColumnDetails.template_column.title,
                descriptions: getTemplateColumnDetails.template_column.descriptions,
                manualDynamicColumns: manualDynamicColumns || "",
                prismDynamicColumns: getTemplateColumnDetails.template_column.prismDynamicColumns || "",
                sortedDynamicColumns: getTemplateColumnDetails.template_column.sortedDynamicColumns || "",
            })
        }
    }, [getTemplateColumnDetails.template_column]);

    const getManualDynamicColumns = () => {
        if (!getTemplateColumnDetails?.template_column?.sortedDynamicColumns?.length) {
            return [];
        }

        const prismDynamicColumns = getTemplateColumnDetails.template_column.prismDynamicColumns
            ?.map(column => column.columnName)
            || [];

        return getTemplateColumnDetails.template_column.sortedDynamicColumns
            .filter(column => !prismDynamicColumns.includes(column.columnName));
    };

    useEffect(() => {
        setTemplateColumnValues([])
        setSentToList([])
        if (location.state?.userList.length === 0) {
            setSubmit(true)
        } else {
            if ((templateColumn.prismDynamicColumns === "" || templateColumn.prismDynamicColumns === undefined) && (templateColumn.manualDynamicColumns === "" || templateColumn.manualDynamicColumns === undefined)) {
                setSubmitEmail(true)
                setSubmit(true)
            } else {
                setSubmit(false)
            }
        }
        const arr = location.state?.userList.toString().split(',')
        if (!templateColumn.manualDynamicColumns <= 0 || templateColumn.manualDynamicColumns !== undefined) {
            arr.map((item, index) => {
                if (templateColumn.manualDynamicColumns.length === 0) {
                    setDynamicColumns(false)
                    setSubmit(true)
                } else {
                    setDynamicColumns(true)
                }

                teacher.map(value => {
                    if (value.id === item) {
                        setTemplateColumnValues(prevState => [
                            ...prevState, {
                                teacherId: value.id,
                                teacherName: value.data
                            }
                        ])
                        addSentTo(value.id)
                    }
                })
            })
        }
    }, [templateColumn.manualDynamicColumns, templateColumn.prismDynamicColumns]);

    useEffect(() => {
        setTemplateColumnValuesEmail([])
        setSentToListEmail([])
        if (location.state?.emails.length === 0) {
            setSubmitEmail(true)
        } else if ((templateColumn.manualDynamicColumns <= 0 || templateColumn.manualDynamicColumns === undefined) && (templateColumn.prismDynamicColumns <= 0 || templateColumn.prismDynamicColumns === undefined)) {
            setSubmitEmail(true)
            setSubmit(true)
        } else if ((!templateColumn.manualDynamicColumns <= 0 || templateColumn.manualDynamicColumns !== undefined) || (!templateColumn.prismDynamicColumns <= 0 || templateColumn.prismDynamicColumns !== undefined)) {
            setSubmitEmail(false)
        }
        location.state?.emails.forEach((value) => {
            setTemplateColumnValuesEmail(prevState => [
                ...prevState, {
                    email: value,
                }
            ])
            addSentToEmail(value)
        })
    }, [templateColumn.manualDynamicColumns, templateColumn.prismDynamicColumns]);

    const addSentTo = (sentToId) => {
        const standardDynamicFields =  templateColumn.manualDynamicColumns.map(column => ({
            columnName: column.columnName,
            columnValue: column.columnValue
        })) || [];
        const newEntry = {
            sentToId: sentToId,
            dynamicColumns: standardDynamicFields,
        };
        setSentToList(prev => [...prev, newEntry]);
        templateColumn.manualDynamicColumns.map((data, index) => {
            const newInputs = {...inputs, [sentToId + data.columnName]: ""};
            setInputs(newInputs);
        })
    };

    const addSentToEmail = (sentToId) => {
        if (templateColumn.manualDynamicColumns && templateColumn.manualDynamicColumns !== "") {
            setConcatColumns(templateColumn.sortedDynamicColumns);
            const combined = [
                ...templateColumn.prismDynamicColumns,
                ...templateColumn.manualDynamicColumns
            ];

            const isDuplicate = sentToListEmail.some(entry => entry.sentToEmail === sentToId);
            if (!isDuplicate) {
                const newEntry = {
                    sentToEmail: sentToId,
                    dynamicColumns: combined.map(column => ({
                        columnName: column.columnName,
                        columnValue: column.columnValue
                    }))
                };

                setSentToListEmail(prev => [...prev, newEntry]);

                combined.forEach((data) => {
                    const newInputs = {...inputsEmail, [sentToId + data.columnName]: ""};
                    setInputsEmail(newInputs);
                });
            }
        }
    };

    const handleInputChange = (teacher, event, columnName) => {
        const newInputs = {...inputs, [teacher + columnName]: event.target.value};
        setInputs(newInputs);

        const updatedList = sentToList.map(task => {
            if (task.sentToId === teacher) {
                const updatedColumns = task.dynamicColumns.map(column => {
                    if (column.columnName.toString() === columnName.toString()) {
                        return {...column, columnValue: event.target.value};
                    }
                    return column;
                });
                return {...task, dynamicColumns: updatedColumns};
            }
            return task;
        });
        setSentToList(updatedList);

        const allFieldsFilled = Object.values(newInputs).every(value => value.trim() !== '');

        if (allFieldsFilled) {
            setSubmit(true)
        } else {
            setSubmit(false)
        }
    };


    const handleInputChangeEmail = (email, event, columnName) => {
        const newInputs = {...inputsEmail, [email + columnName]: event.target.value};
        setInputsEmail(newInputs);

        const updatedList = sentToListEmail.map(task => {
            if (task.sentToEmail === email) {
                const updatedColumns = task.dynamicColumns.map(column => {
                    if (column.columnName === columnName) {
                        return {...column, columnValue: event.target.value};
                    }
                    return column;
                });
                return {...task, dynamicColumns: updatedColumns};
            }
            return task;
        });
        setSentToListEmail(updatedList);

        const allFieldsFilled = Object.values(newInputs).every(value => value.trim() !== '');
        setSubmitEmail(allFieldsFilled);
    }

    const showHeaders = (data) => {
        if (data) {
            return (
                <>
                    <div className="cell">Full Name</div>
                    {
                        data.map(item => {
                            try {
                                return (
                                    <div className="cell">{item.columnName} </div>
                                )
                            } catch (e) {
                                alert(e.message);
                            }
                        })
                    }
                </>
            )
        }
    }
    const showHeadersEmail = (data) => {
        if (data) {
            return (
                <>
                    <div className="cell">Email</div>
                    {
                        data.map((item) => {
                            try {
                                return (
                                    <div className="cell">{item.columnName} </div>
                                )
                            } catch (e) {
                                alert(e.message);
                            }
                        })
                    }
                </>
            )
        }
    }

    const showUsers = (data) => {
        if (data) {
            return data.map((item, index) => {
                try {
                    return (
                        <React.Fragment key={index}>
                            <div key={index} className="preview-row background-1">
                                <div className="cell-row">{item.teacherName}</div>
                                <>
                                    {templateColumn.manualDynamicColumns.map((data, index) => {
                                        const inputKey = item.teacherId + data.columnName;

                                        return (
                                            <div key={inputKey} className="cell-row">
                                                <input
                                                    defaultValue=""
                                                    onChange={(event) => handleInputChange(item.teacherId, event, data.columnName)}
                                                    className={"preview-table-body-input"}
                                                />
                                            </div>
                                        );
                                    })}
                                </>
                            </div>
                        </React.Fragment>
                    );
                } catch (e) {
                    console.error(e);
                }
            });
        }
    };

    const showEmails = (data) => {
        if (data) {
            return data.map((item, index) => {
                try {
                    return (
                        <React.Fragment key={index}>
                            <div key={index} className="preview-row background-1">
                                <div className="cell-row">{item.email}</div>
                                <>
                                    {concatColumns.map((data) => {
                                        const inputKey = item.email;

                                        return (
                                            <div key={inputKey} className="cell-row">
                                                <input
                                                    defaultValue=""
                                                    onChange={(event) => handleInputChangeEmail(item.email, event, data.columnName)}
                                                    className={"preview-table-body-input"}
                                                />
                                            </div>
                                        );
                                    })}
                                </>
                            </div>
                        </React.Fragment>
                    );
                } catch (e) {
                    console.error(e); // Log any potential errors
                }
            });
        }
    };
    const showUsersOnly = (data) => {
        if (data) {
            return data.map((item, index) => {
                try {
                    return (
                        <React.Fragment key={index}>
                            <div key={index} className="preview-row background-1">
                                <div className="cell-row">{item.teacherName} </div>
                            </div>
                        </React.Fragment>
                    )
                } catch (e) {

                }
            })
        }
    }

    const closeAlert = () => {
        setAlertModal({
            display: false
        })
    }

    const setIsSignatureRequired = () => {
        setFieldData({ ...fieldData, isSignRequired: !fieldData.isSignRequired });
    }

    return (
        <>
            {loading && <div class="loader-full-view"><Loader/></div>}
            {loadingSend && <div class="loader-full-view"><Loader/></div>}
            {alertModal.display &&
                <div class="modal-full-view">
                    <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>
                </div>
            }

            <div>
                <p className="notice-preview-heading">
                    {templateColumn.title}
                </p>
                <div className="notice-preview-body">
                    {dynamicColumns && location.state?.userList.length > 0 && <div>
                        {(templateColumn.manualDynamicColumns !== '' || templateColumn.manualDynamicColumns !== undefined) &&
                            <Row className={`preview-table ${location.state?.emails.length > 0 ? '' : 'mb-4'}`}>
                                <div className="background-1 preview-table-header">
                                    {showHeaders(templateColumn.manualDynamicColumns)}
                                </div>
                                {(templateColumnValues !== {} || templateColumnValues !== undefined) &&
                                    <div className="background-1 preview-table-body">
                                        {showUsers(templateColumnValues)}
                                    </div>}
                            </Row>}
                    </div>}

                    {!dynamicColumns && location.state?.userList.length > 0 && <div>
                        {(templateColumn.manualDynamicColumns !== '' || templateColumn.manualDynamicColumns !== undefined) &&
                            <Row className={`preview-table ${location.state?.emails.length > 0 ? '' : 'mb-4'}`}>
                                <div className="background-1 preview-table-header">
                                    {showHeaders(templateColumn.manualDynamicColumns)}
                                </div>
                            </Row>
                        }{(templateColumn.manualDynamicColumns !== '' || templateColumn.manualDynamicColumns !== undefined) &&
                        <Row className={`preview-table ${location.state?.emails.length > 0 ? '' : 'mb-4'}`}>
                            <div className="background-1 preview-table-body">
                                {showUsersOnly(templateColumnValues)}
                            </div>
                        </Row>
                    }
                    </div>}

                    {dynamicColumnsEmail && location.state?.emails.length > 0 && <div className="mt-4">
                        {((!templateColumn.manualDynamicColumns <= 0 || templateColumn.manualDynamicColumns !== undefined) || (!templateColumn.prismDynamicColumns <= 0 || templateColumn.prismDynamicColumns !== undefined)) &&
                            <Row className="preview-table mb-4">
                                <div className="background-1 preview-table-header">
                                    {showHeadersEmail(concatColumns)}
                                </div>
                                {(templateColumnValues !== {} || templateColumnValues !== undefined) &&
                                    <div className="background-1 preview-table-body">
                                        {showEmails(templateColumnValuesEmail)}
                                    </div>}
                            </Row>}
                    </div>}

                    <div className="mb-2">
                        {template_column?.documentText && <HTMLViewer htmlContent={template_column?.documentText}/>}
                    </div>
                </div>
                <Row className="mt-4 button-size-25 background-1" style={{width: "100%"}}>
                    <Col lg={{span: 5}} md={{span: 5}}/>
                    <Col lg={{span: 4}} md={{span: 4}}>
                        <div className="mt-2">
                            <Form.Check
                                className="template-check"
                                name="new_template"
                                label="Require a signature for these letters?"
                                type="checkbox"
                                id="1"
                                checked={fieldData.isSignRequired}
                                onClick={() => setIsSignatureRequired()}
                            />
                        </div>
                    </Col>
                    <Col lg={{ span: 3 }} md={{ span: 3 }} className="padding-right-unset">
                        <div
                            className={`button-solid ${submit && submitEmail ? 'button-active' : 'button-inactive'}`}
                            onClick={submit && submitEmail ? gotoLetters : undefined}
                            style={{ cursor: submit && submitEmail ? 'pointer' : 'not-allowed' }}
                        >
                            <Send className="sidebar-icon" color="var(--white)" /> Send Letters
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    )
        ;
}

export default LettersPreviewManualTab;
